/**
 * Request tracing. mm-be's observability middleware reuses a client-sent
 * `X-Request-ID` for its structured log line and echoes it back on the
 * response, so a failure a member reports can be found in the server logs by
 * the id the browser sent.
 *
 * Its own module because two callers need it and neither may import the
 * other: api/client.ts, and the bare-fetch token refresh in lib/auth/store.ts.
 */

export const REQUEST_ID_HEADER = 'X-Request-ID'

/**
 * A v4 UUID.
 *
 * `crypto.randomUUID` exists only in a secure context — https, or localhost.
 * Dev opened from a phone over the LAN (http://192.168.x.x:5173) is neither,
 * and without the fallback every request would throw before it was sent.
 * `getRandomValues` has no such restriction.
 */
export const newRequestId = (): string => {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID()

  const b = crypto.getRandomValues(new Uint8Array(16))
  b[6] = ((b[6] ?? 0) & 0x0f) | 0x40 // version 4
  b[8] = ((b[8] ?? 0) & 0x3f) | 0x80 // RFC 4122 variant
  const hex = Array.from(b, (n) => n.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
